module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABoSURBVCiRY2DABAYMDAzrsYiTBBQYGBh2MjAwOFNiiDDUkABKDBFgYGBYw8DAkECJIZwMDAxzGBgYiikxhJGBgaGfARLAyykw5zMT1DCqAJjXiqhhGFUCGwaoEv0woMBAhQQJA2RlEQBcJwzzGGgFKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/images/img_20.png
// module id = 2Vs+
// module chunks = 2 6